module.exports = __webpack_public_path__ + "img/parallax.b1b5f773.jpeg";